exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sub-total-summary[data-v-753f6e13],.total-shipping-summary[data-v-753f6e13]{margin-top:20px;font-weight:300;font-size:1.9rem;display:block}", ""]);

// exports
